module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row mt-2"
  }, [_vm._l((_vm.items), function(item, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.items.length > 0),
        expression: "items.length > 0"
      }],
      key: item.id || index,
      staticClass: "col-md-4"
    }, [_c('div', {
      staticClass: "btn-group btn-block mb-1 mr-1"
    }, [_c('button', {
      staticClass: "btn btn-sm btn-secondary",
      class: {
        'active': index == _vm.activeTab
      },
      on: {
        "click": function($event) {
          return _vm.changePosition(item, index)
        }
      }
    }, [_vm._v("\n        " + _vm._s(index + 1) + "\n        ")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-block btn-sm btn-outline-secondary",
      class: {
        'active': index == _vm.activeTab
      },
      on: {
        "click": function($event) {
          return _vm.changePosition(item, index)
        }
      }
    }, [_vm._v("\n        " + _vm._s(_vm._f("firstAndLastName")(_vm.contactName(item))) + "\n      ")])])])
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.items.length == 0),
      expression: "items.length == 0"
    }],
    staticClass: "col-md-4"
  }, [_vm._m(0)])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btn-group btn-block mb-1 mr-1"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-secondary active"
  }, [_vm._v("0")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-block btn-sm btn-outline-secondary active"
  }, [_vm._v("SEM CONTATO")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-690f2630","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/custom/Tabs.vue
// module id = 748
// module chunks = 7